<template>
  <q-btn
    v-bind="$attrs"
    dense
    :class="['bookings-action-button', typeClass]"
  >
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps" />
    </template>
  </q-btn>
</template>

<script>
export default {
  name: "AppActionButton",
  props: {
    type: {
      type: String,
      required: true,
      validator: (val) => ["accept", "cancel", "rotate"].includes(val)
    }
  },
  computed: {
    typeClass() {
      const classMap = {
        accept: "accept-btn",
        cancel: "cancel-btn",
        rotate: "rotate-btn"
      };
      return classMap[this.type] || "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';

.bookings-action-button {
  border-radius: 8px;
  padding: 0.25rem 0.75rem;
  font-size: 0.85rem;
  text-transform: uppercase;
  transition: all 0.2s ease;
  background-color: $accent;
  box-shadow: none !important;
}

.bookings-action-button:hover {
  color: white !important;
}

.accept-btn {
  color: $secondary;
  border: 1px solid $secondary;
  margin: 0.25rem 0.25rem 0 0.25rem;
}
.accept-btn:hover {
  background-color: $positive !important;
  border-color: $positive !important;
}

.cancel-btn {
  color: $secondary;
  border: 1px solid $secondary;
  margin: 0.25rem 0.25rem 0 0.25rem;
}
.cancel-btn:hover {
  background-color: $primary !important;
  border-color: $primary !important;
}

.rotate-btn {
  color: $secondary;
  border: 1px solid $secondary;
  margin: 0.25rem 0.25rem 0 0.25rem;
}
.rotate-btn:hover {
  background-color: $warning !important;
  border-color: $warning !important;
}
</style>
